import React, { useState } from "react";

/**
 * PreviewFrame
 * ------------
 * Applies the spec's 3D perspective transform to the device mockup subtree.
 * Default tilt: perspective(1400px) rotateY(-8deg) rotateX(2deg).
 * On hover/focus the device straightens to face the viewer (rotateY/X -> 0deg).
 *
 * Props:
 *   - variant:   string — preview variant key (e.g. "IG_Feed_4x5"). Forwarded via data attribute.
 *   - className: optional class name appended to the wrapper.
 *   - style:     optional inline style overrides (merged last).
 *   - children:  the <DeviceFrame> subtree.
 *
 * Reference: Vella_Preview_Mockup_Spec.md section 8.5 (the "3D" effect).
 */
export default function PreviewFrame({ variant, className, style, children }) {
  const [hovered, setHovered] = useState(false);

  const tiltedTransform = "perspective(1400px) rotateY(-8deg) rotateX(2deg)";
  const straightTransform = "perspective(1400px) rotateY(0deg) rotateX(0deg)";

  const baseStyle = {
    display: "inline-block",
    transformOrigin: "center center",
    transform: hovered ? straightTransform : tiltedTransform,
    transition: "transform 0.4s ease",
    filter:
      "drop-shadow(0 40px 60px rgba(0,0,0,0.25)) drop-shadow(0 12px 16px rgba(0,0,0,0.2))",
  };

  return (
    <div
      className={["vella-preview-frame", className].filter(Boolean).join(" ")}
      data-preview-variant={variant || undefined}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onFocus={() => setHovered(true)}
      onBlur={() => setHovered(false)}
      style={{ ...baseStyle, ...(style || {}) }}
    >
      {children}
    </div>
  );
}
